import { render, staticRenderFns } from "./insSubmit.vue?vue&type=template&id=584455e2&scoped=true&"
import script from "./insSubmit.vue?vue&type=script&lang=js&"
export * from "./insSubmit.vue?vue&type=script&lang=js&"
import style0 from "./insSubmit.vue?vue&type=style&index=0&id=584455e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584455e2",
  null
  
)

export default component.exports